// @flow
import React from 'react'
import { Checkbox, FormControlLabel, Grid, TextField } from '@material-ui/core'
import i18n from 'i18next'
import styles from './styles'

type Props = {
  newCreditCard: Object,
  onInputChange: Function,
  onSubmit: Function
}

export const CreditCardForm = (props: Props) => (
  <Grid item xs={12}>
    <form onSubmit={props.onSubmit}>
      <Grid container spacing={16}>
        <Grid item xs={12} sm={6}>
          <TextField
            error={props.newCreditCard.formFields.holder.error}
            helperText={
              props.newCreditCard.formFields.holder.error &&
              i18n.t('checkout.error.holder')
            }
            id='payment-holder'
            label={i18n.t('checkout.label.holder')}
            name='holder'
            value={props.newCreditCard.formFields.holder.value}
            onChange={props.onInputChange}
            margin='none'
            variant='outlined'
            required
            type='text'
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            error={props.newCreditCard.formFields.number.error}
            helperText={
              props.newCreditCard.formFields.number.error &&
              i18n.t('checkout.error.cardNumber')
            }
            id='payment-number'
            label={i18n.t('checkout.label.cardNumber')}
            name='number'
            value={props.newCreditCard.formFields.number.value}
            onChange={props.onInputChange}
            margin='none'
            variant='outlined'
            required
            type='number'
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            error={props.newCreditCard.formFields.expirationMonth.error}
            helperText={
              props.newCreditCard.formFields.expirationMonth.error &&
              i18n.t('checkout.error.cardExpirationMonth')
            }
            id='payment-expirationMonth'
            label={i18n.t('checkout.label.cardExpirationMonth')}
            placeholder='00'
            name='expirationMonth'
            value={props.newCreditCard.formFields.expirationMonth.value}
            onChange={props.onInputChange}
            margin='none'
            variant='outlined'
            required
            type='number'
            fullWidth
            inputProps={{ min: 1, max: 12, step: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            error={props.newCreditCard.formFields.expirationYear.error}
            helperText={
              props.newCreditCard.formFields.expirationYear.error &&
              i18n.t('checkout.error.cardExpirationYear')
            }
            id='payment-expirationYear'
            label={i18n.t('checkout.label.cardExpirationYear')}
            placeholder='00'
            name='expirationYear'
            value={props.newCreditCard.formFields.expirationYear.value}
            onChange={props.onInputChange}
            margin='none'
            variant='outlined'
            required
            type='number'
            fullWidth
            inputProps={{ min: 18, max: 99, step: 1 }}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            error={props.newCreditCard.formFields.cvv.error}
            helperText={
              props.newCreditCard.formFields.cvv.error &&
              i18n.t('checkout.error.cardCVV')
            }
            id='payment-cvv'
            label={i18n.t('checkout.label.cardCVV')}
            name='cvv'
            value={props.newCreditCard.formFields.cvv.value}
            onChange={props.onInputChange}
            margin='none'
            variant='outlined'
            required
            type='number'
            fullWidth
            inputProps={{ min: 100, max: 999, step: 1 }}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControlLabel
            style={styles.checkboxWrapper}
            control={
              <Checkbox
                checked={props.newCreditCard.formFields.remember.value}
                name='remember'
                onChange={props.onInputChange}
                value={`${String(
                  props.newCreditCard.formFields.remember.value
                )}`}
              />
            }
            label={i18n.t('checkout.label.saveForFuture')}
          />
        </Grid>
      </Grid>
    </form>
  </Grid>
)

export default CreditCardForm
